import { MyOpenFeedback } from 'model';
import { createAsyncAction } from 'typesafe-actions';

export const getMyOpenFeedbackItems = createAsyncAction(
  'myOpenFeedback/GET_MYOPENFEEDBACK_ITEMS_REQUEST',
  'myOpenFeedback/GET_MYOPENFEEDBACK_ITEMS_SUCCESS',
  'myOpenFeedback/GET_MYOPENFEEDBACK_ITEMS_FAILURE',
)<undefined, MyOpenFeedback, undefined>();
